// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from 'C:/D/work/XLChat/xl-tousu-web/node_modules/.store/@ant-design+icons@4.8.3/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import FormOutlined from 'C:/D/work/XLChat/xl-tousu-web/node_modules/.store/@ant-design+icons@4.8.3/node_modules/@ant-design/icons/es/icons/FormOutlined';
import SettingOutlined from 'C:/D/work/XLChat/xl-tousu-web/node_modules/.store/@ant-design+icons@4.8.3/node_modules/@ant-design/icons/es/icons/SettingOutlined';
export default { DashboardOutlined, FormOutlined, SettingOutlined };
